<template>
	<button
		class="btn btn-secondary"
		type="button"
		@click="handleClickDownload"
	>
		Download Color Mix
	</button>
</template>


<style lang="scss">

</style>


<script setup>
import { DownloadablePdf } from '../classes/DownloadablePdf'


const props = defineProps({
	colorData: {
		type: Array,
		required: true,
	},
	siteLogoUrl: {
		type: String,
		required: true,
	},
	pdfTextDisclaimer: {
		type: String,
		default: '',
	},
	pdfTextContact: {
		type: String,
		default: '',
	},
})


/**
 * Handle user clicking to download PDF
 *
 * @return {void}
 */
const handleClickDownload = async () => {
	const mixComp = window?.webfx?.colorMixer?.mixComp

	if ( !mixComp ) {
		console.warn( 'Mix composition has not yet been created!' )
		return
	}

	const selectedColors = props.colorData
		.toSorted( ( a, b ) => a.percentage - b.percentage )
		.toReversed()

	// eslint-disable-next-line arrow-body-style
	const breakoutText = selectedColors
		.map( color => `${color.percentage}% - ${color.title}` )
		.join( '\n' )

	const downloadablePdf = new DownloadablePdf()

	// for code-splitting, we're using an async dynamic import
	await downloadablePdf.createPdf()

	downloadablePdf
		.addLogoImage( props.siteLogoUrl )
		.addBreakoutText( breakoutText )
		.addDisclaimerText( props.pdfTextDisclaimer )
		.addContactUsText( props.pdfTextContact )

	// this needs to await because of generating an image
	await downloadablePdf.addMixImage( mixComp.getCanvasDataUrl() )

	const fileName = `No Fault - ${selectedColors.map( color => color.title ).join( ', ' )}.pdf`

	// will save to user browser
	downloadablePdf.saveToBrowser( fileName )
}


</script>
